import React from 'react';
import { Flexbox, Heading2 } from '@ibinder/common-frontend';
import { miniClose } from '@ibinder/common-icons';
import styled from 'styled-components';

const ModalWrapper = styled(Flexbox)`
  position: fixed;
  justify-content: center;
  width: 100%;
  height: 100%;
  z-index: 10;
  top: 1rem;
  left: 0;

  &::after {
    content: '';
    height: 100%;
    width: 100%;
    background: black;
    opacity: 0.5;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 450;
  }
`;

const ModalInnerWrapper = styled.div`
  // USING FLEXBOX WILL BREAK THE FORWARD REF >:(
  width: 676px;
  height: 95%;
  background: ${({ theme }) => theme.colors.accent};
  z-index: 500;
  display: flex;
  flex-direction: column;
`;

const CloseBtn = styled.span`
  cursor: pointer;
`;
const ModalHeader = styled(Flexbox)`
  border-top: 1rem solid ${(p) => p.theme.colors.primary};
  padding: 0 1rem;
  justify-content: space-between;
  align-items: center;
`;

type Props = {
  label: string;
  name: string;
  Component: React.FunctionComponent;
  onClose: Function;
  loading: boolean;
} & React.HTMLAttributes<HTMLButtonElement>;

const AdminModal = React.forwardRef<HTMLDivElement, Props>(
  ({ label, name, onClose, Component, loading, ...rest }, ref) => (
    <ModalWrapper>
      <ModalInnerWrapper ref={ref}>
        <ModalHeader>
          <Heading2 label={label} loading={loading} />
          <CloseBtn onClick={onClose}>{miniClose}</CloseBtn>
        </ModalHeader>
        <Component {...{ onClose }} {...rest} />
      </ModalInnerWrapper>
    </ModalWrapper>
  )
);

export default AdminModal;
